import type { I18N_CONF } from '@funkey/locales/config';
import { UrlPath } from '~/utils/routing';
import type { headers as nextHeaders } from 'next/headers';
import type { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';
import type { next } from '..';

export function getPathname(headers: ReadonlyHeaders) {
    return new UrlPath(X_URLHeader.get(headers).rawPath);
}

/** A header containing useful routing information.
 *
 * This gets set inside the proxy */
export namespace X_URLHeader {
    export const HEADER_NAME = 'x-funkey-url';

    export type Type = {
        // TODO
        // /** Pathname without the leading locale  */
        // routerPath: string;

        /** Pathname with the leading locale */
        rawPath: `/${string}`;

        hash: string | null;
        /** Domain of the request */
        domain:
            | I18N_CONF.Domain
            | `funkey-web-git-${string /* Branch slug */}-funkey.vercel.app`
            | (string & {});
        /** String encoded `URLSearchParams`
         *
         * @todo: maybe this should be decoded when reading the header */
        search: `?${string}` | null;

        locale: I18N_CONF.Locale;
        language: I18N_CONF.Language;
        country: I18N_CONF.Country;
    };

    /** Get this header from inside a server component or route handler */
    export function get(
        headers: Awaited<Awaited<ReturnType<typeof nextHeaders>>>,
    ): X_URLHeader.Type {
        const value = headers.get(HEADER_NAME);
        if (!value) throw new Error(`Missing required header "${HEADER_NAME}"`);
        return JSON.parse(value);
    }
}

export async function pageProps<P extends next.UnknownParams, SP extends next.UnknownParams>(
    props: next.PageProps.AwaitedOrPending<P, SP>,
): Promise<{ params: P; searchParams: SP }> {
    const [params, searchParams] = await Promise.all([props.params, props.searchParams]);
    return { params, searchParams };
}
